import { put, takeLatest } from "redux-saga/effects";

import {
  requestLocationList,
  requestCreateLocation,
  requestupdateLocation,
  requestDeleteLocation,
} from "../../../services/location";
import {
  fetchLocationListFailure,
  fetchLocationListRequest,
  fetchLocationListSuccess,
  createLocationRequest,
  createLocationSuccess,
  createLocationFailure,
  updateLocationRequest,
  updateLocationSuccess,
  updateLocationFaliure,
  deleteLocationListRequest,
  deleteLocationListSuccess,
  deleteLocationListFaliure,
} from "../../reducers/location";

export function* watchLocationSaga() {
  yield takeLatest(fetchLocationListRequest, fetchLocationList);
  yield takeLatest(createLocationRequest, createLocation);
  yield takeLatest(updateLocationRequest, updateLocation);
  yield takeLatest(deleteLocationListRequest, deleteLocation);
}

/**
 *
 * @param {*} param0
 */
function* fetchLocationList({ payload }) {
  try {
    const response = yield requestLocationList(payload);
    yield put(fetchLocationListSuccess(response));
  } catch (error) {
    yield put(fetchLocationListFailure("Failed to get list of location"));
  }
}
function* createLocation({ payload }) {
  try {
    //service add
    const response = yield requestCreateLocation(payload);
    yield put(createLocationSuccess(response.data));
  } catch (error) {
    yield put(createLocationFailure("Failed to create Location"));
  }
}

function* updateLocation({ payload }) {
  try {
    const response = yield requestupdateLocation(payload);
    yield put(updateLocationSuccess(response.data));
  } catch (error) {
    yield put(updateLocationFaliure("Failed to get update Location"));
  }
}

function* deleteLocation({ payload }) {
  try {
    const response = yield requestDeleteLocation(payload);
    yield put(deleteLocationListSuccess(response.data));
  } catch (error) {
    yield put(deleteLocationListFaliure("Failed to get Delete Location"));
  }
}